import { render, staticRenderFns } from "./multipleChoiceShare_fixedBtn.vue?vue&type=template&id=1e2c7794&scoped=true"
import script from "./multipleChoiceShare_fixedBtn.vue?vue&type=script&lang=js"
export * from "./multipleChoiceShare_fixedBtn.vue?vue&type=script&lang=js"
import style0 from "./multipleChoiceShare_fixedBtn.vue?vue&type=style&index=0&id=1e2c7794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c7794",
  null
  
)

export default component.exports